import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { FaInfoCircle } from "react-icons/fa";  
import { FilePlus, ArrowUpCircle, Download } from "lucide-react";
import "./datepicker.css"

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const WarehouseIndents = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [highlightedDates, setHighlightedDates] = useState([]);


  // Filter states
  const [cycleDate, setCycleDate] = useState("");
  const [destination, setDestination] = useState({ label: "ALL", value: "" });
  const [destinationOptions, setDestinationOptions] = useState([{ label: "ALL", value: "" }]);
  const today = new Date().toLocaleDateString("en-CA", {
    timeZone: "Asia/Kolkata",
  });
  const [latestCycleDate, setLatestCycleDate] = useState(today);


  const [currentDate, setCurrentDate] = useState(today);
  const [isTrigger, setIsTrigger] = useState(null);

  const [triggerStatus, setTriggerStatus] = useState(null);
  const [triggerNote, setTriggerNote] = useState(null);


  // Slider state for Trigger Warehouse Indents
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [triggerDate, setTriggerDate] = useState("");
  const [isTriggering, setIsTriggering] = useState(false);

  // Download functionality
  const [isDownloading, setIsDownloading] = useState(false);

  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);

  
 // Old CustomHeader component
//    const CustomHeader = (props) => {
//      const tooltip = props?.column?.getColDef()?.headerTooltip || "";
//      const [showMenu, setShowMenu] = useState(false);
//      const [showTooltip, setShowTooltip] = useState(false);
   
//      const onMenuClick = (event) => {
//        props.showColumnMenu(event.currentTarget);
//      };
   
//      return (
//        <div
//          style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
//          onMouseEnter={() => setShowMenu(true)}
//          onMouseLeave={() => setShowMenu(false)}
//        >
//          {/* Header Name */}
//          <span style={{ cursor: "default" }}>{props.displayName}</span>
   
//          {/* Info Icon with instant tooltip */}
//          <div
//            style={{ position: "relative", display: "inline-block" }}
//            onMouseEnter={() => setShowTooltip(true)}
//            onMouseLeave={() => setShowTooltip(false)}
//          >
//            <FaInfoCircle style={{ fontSize: 18, opacity: 0.7,  }} />
         
//          </div>
   
//          {/* Menu Button (☰) visible only on hover */}
//          {props.enableMenu && (
//            <span
//              onClick={onMenuClick}
//              style={{
//                marginLeft: "5px",
//                cursor: "pointer",
//                fontSize: 14,
//                opacity: showMenu ? 1 : 0,
//                transition: "opacity 0.2s ease",
//              }}
//            >
//              ☰
//            </span>
//          )}
//        </div>
//      );
//    };
        const getHighlightedDates = async () => {  
      try {
        const response = await redirectURL.post("indentation/getWHRaiseddates", {});
        if (response.status === 200 && response.data.dates) {
          const dates = response.data.dates.map(dateStr => {
            try {
              return new Date(dateStr);
            } catch (e) {
              return null;
            }
          }).filter(date => date !== null);
          setHighlightedDates(dates);
        }
      } catch (error) {
        console.error("Failed to fetch highlighted dates:", error);
      }
    }
    // New CustomHeader component
    const CustomHeader = (props) => {
        const tooltip = props?.column?.getColDef()?.headerTooltip || "";
        const [showMenu, setShowMenu] = useState(false);
        const [showTooltip, setShowTooltip] = useState(false);

        const onMenuClick = (event) => {
            props.showColumnMenu(event.currentTarget);
        };

        // Handle sort icon click
        const onSortRequested = (order, event) => {
            props.setSort(order, event?.shiftKey);
        };

        // Get current sort state
        const getSort = () => {
            return props.column.getSort();
        };

        // Check if sorting is enabled for this column
        const isSortable = props.column.getColDef().sortable;

        return (
            <div
                style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
                onMouseEnter={() => setShowMenu(true)}
                onMouseLeave={() => setShowMenu(false)}
            >
                {/* Header Name - Make it clickable for sorting */}
                <span
                    style={{
                        cursor: isSortable ? "pointer" : "default",
                        userSelect: "none"
                    }}
                    onClick={isSortable ? () => {
                        const currentSort = getSort();
                        let newSort = 'asc';
                        if (currentSort === 'asc') newSort = 'desc';
                        else if (currentSort === 'desc') newSort = null;
                        onSortRequested(newSort, null);
                    } : undefined}
                >
                    {props.displayName}
                </span>

                {/* Sort indicator */}
                {isSortable && (
                    <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: 10,
                                opacity: getSort() === 'asc' ? 1 : 0.3,
                                lineHeight: "8px"
                            }}
                            onClick={() => onSortRequested('asc', null)}
                        >
                            {/* ↑ */}
                        </span>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: 10,
                                opacity: getSort() === 'desc' ? 1 : 0.3,
                                lineHeight: "8px"
                            }}
                            onClick={() => onSortRequested('desc', null)}
                        >
                            {/* ↓ */}
                        </span>
                    </div>
                )}

                {/* Info Icon with instant tooltip */}
                <div
                    style={{ position: "relative", display: "inline-block" }}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

                    {/* Tooltip */}
                    {showTooltip && tooltip && (
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                // backgroundColor: "rgba(0, 0, 0, 0.8)",
                                color: "white",
                                padding: "8px 12px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                zIndex: 1000,
                                marginTop: "5px",
                                // pointerEvents: "none", // Add this line
                            }}
                        >
                            {tooltip}
                        </div>
                    )}
                </div>

                {/* Menu Button (☰) visible only on hover */}
                {props.enableMenu && (
                    <span
                        onClick={onMenuClick}
                        style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: 14,
                            opacity: showMenu ? 1 : 0,
                            transition: "opacity 0.2s ease",
                        }}
                    >
                        ☰
                    </span>
                )}
            </div>
        );
    };

  const columnWithDefs = [
    {
      headerName: "Destination Store ID",
      field: "destination_store_id",
      tooltipField: "destination_store_id",
      sortable: true,
      resizable: true,
      width: 150,
    },
    {
      headerName: "Destination Store Name",
      field: "destination_store_name",
      tooltipField: "destination_store_name",
      sortable: true,
      resizable: true,
      width: 180,
    },
    {
      headerName: "Destination Type",
      field: "destination_type",
      tooltipField: "destination_type",
      sortable: true,
      resizable: true,
      width: 150,
    },
    {
      headerName: "Source Name",
      field: "plant_name",
      tooltipField: "plant_name",
      sortable: true,
      resizable: true,
      width: 150,
    },
    {
      headerName: "Source ID",
      field: "plant_id",
      tooltipField: "plant_id",
      sortable: true,
      resizable: true,
      width: 120,
    },
    {
      headerName: "Warehouse",
      field: "warehouse",
      tooltipField: "warehouse",
      sortable: true,
      resizable: true,
      width: 130,
    },
    {
      headerName: "F Code",
      field: "f_code",
      tooltipField: "f_code",
      sortable: true,
      resizable: true,
      hide: true,
      width: 120,
    },
    {
      headerName: "SKU Code",
      field: "sku_code",
      tooltipField: "sku_code",
      sortable: true,
      resizable: true,
      width: 120,
    },
    {
      headerName: "SKU Name",
      field: "sku_name",
      tooltipField: "sku_name",
      sortable: true,
      resizable: true,
      width: 200,
    },
    {
      headerName: "SKU Category",
      field: "sku_category",
      tooltipField: "sku_category",
      sortable: true,
      resizable: true,
      width: 150,
    },
      {
      headerName: "SKU Weight (gms)",
      field: "sku_weight_in_gms",
      tooltipField: "sku_weight_in_gms",
      sortable: true,
      resizable: true,
      width: 150,
    },

    {
      headerName: "Cycle Date",
      field: "cycle_date",
      tooltipField: "cycle_date",
      sortable: true,
      resizable: true,
      width: 120,
      valueGetter: (params) => {
        if (params.data && params.data.cycle_date) {
          const date = new Date(params.data.cycle_date);
          return date.toISOString().split("T")[0];
        }
        return "";
      },
    }
    ,
    {
      headerName: "Transit Days",
      field: "transit_days",
      tooltipField: "transit_days",
      sortable: true,
      resizable: true,
      hide: true,
      width: 120,
    },
    {
      headerName: "Packaging Time",
      field: "packaging_time",
      tooltipField: "packaging_time",
      sortable: true,
      hide: true,
      resizable: true,
      width: 140,
    },
    {
      headerName: "Replenishment Cycle Time",
      field: "replenishment_cycle_time",
      tooltipField: "replenishment_cycle_time",
      sortable: true,
      hide: true,
      resizable: true,
      width: 180,
    },
    {
      headerName: "Lead Time",
      field: "lead_time",
      tooltipField: "lead_time",
      sortable: true,
      hide: true,
      resizable: true,
      width: 100,
    },
       {
      headerName: "In Transit Stock",
      field: "in_transit_stock",
      tooltipField: "in_transit_stock",
      sortable: true,
      resizable: true,
      width: 130,
    },
       {
      headerName: "In Warehouse Stock",
      field: "in_warehouse_stock",
      tooltipField: "in_warehouse_stock",
      sortable: true,
      resizable: true,
      width: 130,
    },
          {
      headerName: "Issued Stock",
      field: "issued_stock",
      tooltipField: "issued_stock",
      sortable: true,
      resizable: true,
      width: 130,
    },
       {
      headerName: "Current Stock",
      field: "current_stock",
      tooltipField: "current_stock",
       headerTooltip: "In Transit Stock + In Warehouse Stock + Issued Stock",
      headerComponent: CustomHeader,
      sortable: true,
      resizable: true,
      width: 130,
    },
    {
      headerName: "Physical Norm",
      field: "safety_stock",
      tooltipField: "safety_stock",
      sortable: true,
      resizable: true,
      width: 130,
    },
    {
      headerName: "Warehouse Norm",
      field: "reorder_point_stock",
      tooltipField: "reorder_point_stock",
      sortable: true,
      resizable: true,
      width: 160,
     
    },
    {
      headerName: "Darkstores Demand",
      field: "darkstores_demand",
      tooltipField: "darkstores_demand",
      headerTooltip: "Indents Stock at WH Corresponding Darkstores",
      headerComponent: CustomHeader,
      sortable: true,
      resizable: true,
      width: 180,
    },
    {
      headerName: "Open PO Stock",
      field: "open_po_stock",
      tooltipField: "open_po_stock",
      sortable: true,
      resizable: true,
      width: 130,
      
    },
    {
      headerName: "Final Stock To Be Maintained",
      field: "final_stock_to_be_maintained",
      tooltipField: "final_stock_to_be_maintained",
      headerTooltip: "Warehouse Norm + Darkstores Demand + Open PO Stock",
      headerComponent: CustomHeader,
      sortable: true,
      resizable: true,
      width: 200,
     
    },
    {
      headerName: "Final Current Stock",
      field: "final_current_stock",
      tooltipField: "final_current_stock",
      headerTooltip: "CurrentStock ",
      headerComponent: CustomHeader,
      sortable: true,
      resizable: true,
      width: 160,
    
    },
    {
      headerName: "Indent Stock",
      field: "indent_stock",
      tooltipField: "indent_stock",
      headerTooltip: "Final Stock To Be Maintained - Final Current Stock",
      headerComponent: CustomHeader,
      sortable: true,
      resizable: true,
      width: 130,
    
    },
      {
      headerName: "Indent Weight (gms)",
      field: "indent_weight_in_gms",
      tooltipField: "indent_weight_in_gms",
        headerTooltip: "Indent Stock*SKU Weight(gms)",
      headerComponent: CustomHeader,
      sortable: true,
      resizable: true,
      width: 150,
    },
      {
      headerName: "Indent Weight (kgs) ",
      field: "indent_weight_in_kgs",
      tooltipField: "indent_weight_in_kgs",
      sortable: true,
      resizable: true,
      width: 150,
    },
  ];

const downloadWarehouseIndentsData = async () => {
  if (!cycleDate) {
    setShow(true);
    setBasicTitle("Please select a date to download data");
    setBasicType("info");
    return;
  }

  setIsDownloading(true);
  setLoadshow("show-m");
  setOverlayBlock("show-m");

  try {
    const response = await redirectURL.post(
      "indentation/downloadWarehouseIndentsData",
      { date: cycleDate }
    );

    if (response.data.status === "success") {
      const jsonData = response.data.response?.message;
      const parsedData = JSON.parse(jsonData);

      if (!parsedData.length) {
        setShow(true);
        setBasicTitle("No data available for the selected date");
        setBasicType("info");
        return;
      }

      // 🔹 Format headers and values
      const formattedData = parsedData.map(row => {
        const formattedRow = {};
        Object.entries(row).forEach(([key, value]) => {
          // Format header: capitalize words
          const formattedKey = key
            .split("_")
            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" ");

          // Format value: if date-like (contains 'T'), take 0th part
          let formattedValue = value;
          if (typeof value === "string" && value.includes("T")) {
            formattedValue = value.split("T")[0];
          }

          formattedRow[formattedKey] = formattedValue;
        });
        return formattedRow;
      });

      // 🔹 Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Warehouse_Indents");

      // 🔹 Write Excel file
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const fileName = `Warehouse_Indents_${cycleDate}.xlsx`;
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, fileName);
    } else {
      setShow(true);
      setBasicTitle("No data available for the selected date");
      setBasicType("info");
    }
  } catch (err) {
    console.error("Download error:", err);
    setShow(true);
    setBasicTitle("Failed to download Warehouse Indent data");
    setBasicType("error");

    const userData = {
      email: localStorage.getItem("email"),
      user_code: localStorage.getItem("user_code"),
      action: "Downloaded Warehouse Indents Data",
      status: "Error",
      path: window.location.pathname,
    };
    triggerUserAction(userData);
  } finally {
    setIsDownloading(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }
};

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const checkTriggerStatusByDate = async (date) => {
    try {
      const triggerResponse = await redirectURL.post("indentation/checkTriggerStatusByDate", { trigger_date: date });
      const status = triggerResponse?.data?.status || "fail";
      if (status === "success") {
        setIsTrigger(status);
      } else {
        setIsTrigger(status);
      }
      return status;
    } catch (e) {
      console.error("Error checking trigger status:", e);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle("Something went wrong. Please try again later.");
      setBasicType("error");
      return "fail";
    }
  };

  const onChangeTriggerDate = async (date) => {
    if (!date) return;

    const newDate = date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

    setCurrentDate(newDate);
    setTriggerDate(newDate);

    const status = await checkTriggerStatusByDate(newDate);
    setIsTrigger(status);
  };

  const resetFilters = () => {
    setCycleDate(latestCycleDate);
    setDestination({ label: "ALL", value: "" });
    applyResetFilters();
  };

  const applyResetFilters = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const params = {
        date: latestCycleDate || "",
        destination_store_id: ""
      };

      const response = await redirectURL.post("indentation/getFilteredWarehouseIndentsData", params);

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setFilteredData(response.data.data);

          if (latestCycleDate) {
            await getDestinationOptionsByDate(latestCycleDate);
          }

          setTimeout(() => {
            if (gridApi.current) {
              gridApi.current.sizeColumnsToFit();
            }
          }, 100);
        } else {
          setFilteredData([]);
          setBasicTitle("No data found for the latest cycle date");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error applying reset filters:", error);
      setBasicTitle("Failed to reset filters");
      setBasicType("error");
      setShow(true);
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 180,
  };

  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;

    setTimeout(() => {
      if (gridApi.current) {
        gridApi.current.sizeColumnsToFit();
      }
    }, 100);
  };

  const onFirstDataRendered = (params) => {
    setTimeout(() => {
      if (gridApi.current) {
        gridApi.current.sizeColumnsToFit();
      }
    }, 100);
  };

  const onTriggerSubmit = async (e) => {
    if (!currentDate) {
      setShow(true)
      setBasicTitle("Please select a date")
      setBasicType("info")
      return;
    }
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    setSliderOpen(false)
    setSliderType(null)
    await onTriggerSubmissionFunction()
  };

  // const onTriggerSubmissionFunction = async () => {
  //   try {
  //     const response = await redirectURL.post("indentation/onTriggerWarehouseIndentsStatus", { trigger_date: currentDate })
  //     if (response.data.status === "info") {
  //       setLoadshow("show-n");
  //       setOverlayBlock("show-n");
  //       setTriggerNote(response.data.message);
  //       setTriggerStatus("info");
  //       const userData = {
  //         email: localStorage.getItem("email"),
  //         user_code: localStorage.getItem("user_code"),
  //         action: "Triggered Raise Indents - Warehouse Indentation",
  //         status: "Info",
  //         path: window.location.pathname
  //       };
  //       triggerUserAction(userData);
  //       return
  //     } else if (response.data.status === "success") {
  //       await getWarehouseIndentsData()
  //       setOverlayBlock("show-n");
  //       setLoadshow("show-n");
  //       setShow(true)
  //       setBasicTitle("Raise Indent Triggered Successfully");
  //       setBasicType("success");
  //       const userData = {
  //         email: localStorage.getItem("email"),
  //         user_code: localStorage.getItem("user_code"),
  //         action: "Triggered Raise Indents - Warehouse Indentation",
  //         status: "Success",
  //         path: window.location.pathname
  //       };
  //       triggerUserAction(userData);
  //     } else {
  //       setLoadshow("show-n");
  //       setOverlayBlock("show-n");
  //       setShow(true);
  //       setBasicTitle("Something went wrong. Please try again later.");
  //       setBasicType("error");
  //       const userData = {
  //         email: localStorage.getItem("email"),
  //         user_code: localStorage.getItem("user_code"),
  //         action: "Triggered Raise Indents - Warehouse Indentation",
  //         status: "Error",
  //         path: window.location.pathname
  //       };
  //       triggerUserAction(userData);
  //     }
  //   }
  //   catch (error) {
  //     console.error("Error triggering inventory:", error);
  //     setLoadshow("show-n");
  //     setOverlayBlock("show-n");
  //     setShow(true);
  //     setBasicTitle("Something went wrong. Please try again later.");
  //     setBasicType("error");
  //   }
  // }
const onTriggerSubmissionFunction = async () => {
  try {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const response = await redirectURL.post(
      "indentation/onTriggerWarehouseIndentsStatus",
      { trigger_date: currentDate }
    );

    const res = response?.data?.pyResponse;

    if (res?.status === "Success") {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("success");
      setBasicTitle(res.message);

      await getWarehouseIndentsData();

      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Triggered Raise Indents - Warehouse Indentation",
        status: res.status,
        path: window.location.pathname
      });
    } 
    else {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle(res?.message || "Something went wrong.");

      // optional audit (enable if required)
      /*
      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Triggered Raise Indents - Warehouse Indentation",
        status: res?.status || "Failure",
        path: window.location.pathname
      });
      */
    }

  } catch (error) {
    console.error("Error triggering inventory:", error);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setShow(true);
    setBasicType("error");
    setBasicTitle(
      error?.response?.data?.message || "Something went wrong. Please try again later."
    );
  }
};

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setSliderType(null);
    setTriggerDate("")
    setTriggerStatus(null);
    setTriggerNote("")
  }

  const onClickingPopupContinueBtn = async () => {
    setTriggerStatus(null)
    await onTriggerWarehouseIndents();
    setLoadshow("show-n")
    setOverlayBlock("show-n")
    setTriggerStatus(null);
    setTriggerNote("")
  }

  const getWarehouseIndentsData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post("indentation/getWarehouseIndentsData", {});

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const data = response.data.data;
          setRowData(data);

          const latestDate = getLatestCycleDate(data);
          if (latestDate) {
            setLatestCycleDate(latestDate);
            setCycleDate(latestDate);
            await getDestinationOptionsByDate(latestDate);
            await loadDataForLatestDate(latestDate);
            await getHighlightedDates()
          }

          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No warehouse indents data found");
          setBasicType("info");
          setShow(true);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    } catch (error) {
      console.error("Error fetching warehouse indents data:", error);
      setBasicTitle("Failed to fetch warehouse indents data");
      setBasicType("error");
      setShow(true);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };



const getLatestStockStatusDate = async () => {
  try {
    const response = await redirectURL.post("indentation/getlatestStockstatusDate");
    
    if (response.data.status === "success") {
      const TriggerlatestDate = new Date(response.data.latest_date).toISOString().split("T")[0];
      console.log("Latest Cycle Date:", TriggerlatestDate);
      return TriggerlatestDate;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching latest cycle date:", error);
    return null;
  }
};


  const loadDataForLatestDate = async (date) => {
    try {
      const params = {
        date: date || "",
        destination_store_id: ""
      };

      const response = await redirectURL.post("indentation/getFilteredWarehouseIndentsData", params);

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setFilteredData(response.data.data);
        } else {
          setFilteredData([]);
        }
      }
    } catch (error) {
      console.error("Error loading data for latest date:", error);
      setFilteredData([]);
    }
  };

  const getLatestCycleDate = (data) => {
    if (!data || data.length === 0) return "";

    const dates = data
      .map(item => item.date)
      .filter(date => date)
      .sort((a, b) => new Date(b) - new Date(a));

    return dates.length > 0 ? new Date(dates[0]).toISOString().split('T')[0] : "";
  };

  const getDestinationOptionsByDate = async (date) => {
    try {
      if (!date) {
        setDestinationOptions([{ label: "ALL", value: "" }]);
        return;
      }

      const response = await redirectURL.post("indentation/getDestinationsByCycleDateIndents", {
        date: date
      });

      if (response.status === 200 && response.data.data) {
        const destinations = response.data.data;
        const options = [
          { label: "ALL", value: "" },
          ...destinations.map(dest => ({
            value: dest.destination_store_id,
            label: `${dest.destination_store_id} - ${dest.destination_store_name}`
          }))
        ];
        setDestinationOptions(options);
        setDestination(options[0]);
      }
    } catch (error) {
      console.error("Error fetching destination options:", error);
      setDestinationOptions([{ label: "ALL", value: "" }]);
    }
  };

  const applyFilters = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const params = {
        date: cycleDate || "",
        destination_store_id: destination.value || ""
      };

      const response = await redirectURL.post("indentation/getFilteredWarehouseIndentsData", params);

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setFilteredData(response.data.data);

          setTimeout(() => {
            if (gridApi.current) {
              gridApi.current.sizeColumnsToFit();
            }
          }, 100);
        } else {
          setFilteredData([]);
          setBasicTitle("No data found for the selected filters");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error applying filters:", error);
      setBasicTitle("Failed to apply filters");
      setBasicType("error");
      setShow(true);
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const handleCycleDateChange = async (date) => {
    const dateString = date ? new Date(date).toISOString().split('T')[0] : "";
    setCycleDate(dateString);

    if (dateString) {
      await getDestinationOptionsByDate(dateString);
    } else {
      setDestinationOptions([{ label: "ALL", value: "" }]);
      setDestination({ label: "ALL", value: "" });
    }
  };

  const openTriggerWarehouseIndentsSlider = async () => {
    setLoadshow("show-m")
    setOverlayBlock("show-m")
    const status = await checkTriggerStatusByDate(currentDate);
  const TriggerlatestDate = await getLatestStockStatusDate();
  setLatestCycleDate(TriggerlatestDate);
  setTriggerDate(TriggerlatestDate)
  setCurrentDate(TriggerlatestDate)

    setLoadshow("show-n")
    setOverlayBlock("show-n")
    setSliderType(1);
    setSliderTitle("Trigger Raise Indents");
    setSliderCl("trigger-warehouse-indents-slider");
    setOverlyBlock("show-m");
    setSliderOpen(true);
    setTriggerDate(latestCycleDate );
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    setTriggerDate("");
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setTriggerDate("");
  };

  const onTriggerWarehouseIndents = async (e) => {
    if (!currentDate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please select a date");
      return;
    }

    try {
      setIsTriggering(true);
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const resp = await redirectURL.post("indentation/onTriggerWarehouseIndents", {
        date: currentDate,
      });
      await getWarehouseIndentsData()
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      if (resp.data.status === "success") {
        setShow(true);
        setBasicType("success");
        setBasicTitle("Warehouse indents triggered successfully");
        setSliderOpen(false);
        setOverlyBlock("show-n");
        setTriggerDate("");
        await getWarehouseIndentsData();
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("error");
        setBasicTitle(resp.data.message || "Failed to trigger warehouse indents");
      }
    } catch (err) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("error");
      setBasicTitle("Failed to trigger warehouse indents");
      console.error("Error triggering warehouse indents:", err);
    } finally {
      setIsTriggering(false);
    }
  };

  useEffect(() => {
    const getData = async () => {
      await getWarehouseIndentsData();
    };
    getData();
  }, []);

  const closeAlert = () => {
    setShow(false);
    setSliderOpen(false);
    setTriggerStatus(null)
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <form className="col-sm-12 p-0 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-8 row">
              {/* Cycle Date Filter */}
              <div className="col-sm-3 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Date:
                </label>
                <DatePicker
                  selected={cycleDate ? new Date(cycleDate) : null}
                  onChange={handleCycleDateChange}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  highlightDates={highlightedDates}
                  placeholderText="Select Cycle Date"
                />
              </div>

              {/* Destination Store Filter */}
              <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="destination" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Destination Store:
                </label>
                <Select
                  id="destination"
                  value={destination}
                  onChange={(selectedOption) => setDestination(selectedOption)}
                  options={destinationOptions}
                  styles={selectStyles}
                  isDisabled={!cycleDate}
                />
              </div>

              {/* Filter Buttons */}
              <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                <button
                  type="button"
                  onClick={(e) => { e.preventDefault(); applyFilters(); }}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Apply
                </button>
                <button
                  onClick={(e) => { e.preventDefault(); resetFilters(); }}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            <div className="col-sm-4 mt-4" style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <button
                             type="button"
                             onClick={downloadWarehouseIndentsData}
                             disabled={isDownloading || filteredData.length === 0}
                             style={{
                               backgroundColor: "#fff",
                               color: "#333",
                               border: "1px solid #ccc",
                               borderRadius: "5px",
                               padding: "0px 20px",
                               height: "39px",
                               cursor: (isDownloading || filteredData.length === 0) ? "not-allowed" : "pointer",
                               display: "flex",
                               alignItems: "center",
                               transition: "all 0.2s ease-in-out",
                               marginRight: "10px",
                               opacity: (isDownloading || filteredData.length === 0) ? 0.6 : 1
                             }}
                             onMouseOver={(e) => {
                               if (!isDownloading) {
                                 e.currentTarget.style.transform = "scale(1.05)";
                                 e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                               }
                             }}
                             onMouseOut={(e) => {
                               if (!isDownloading) {
                                 e.currentTarget.style.transform = "scale(1)";
                                 e.currentTarget.style.boxShadow = "none";
                               }
                             }}
                           >
                            <Download size={18} />
                             <span style={{ marginLeft: "7px" }}>
                             Warehouse Indents Data
                             </span>
                           </button>

              {/* Raise Indents Button */}
              <button
                type="button"
                onClick={openTriggerWarehouseIndentsSlider}
                style={{
                  backgroundColor: "#93385D",
                  color: "#fff",
                  borderRadius: "5px",
                  height: "36px",
                  padding: "0 20px",
                  border: "none",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                transition: "all 0.2s ease-in-out",

                }}

                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                }}

                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}

              >
              {/* <ArrowUpCircle size={18} /> */}
               <span style={{marginLeft : "5px"}}>Raise Indents</span>
              </button>
            </div>
          </form>

          {/* Data Grid */}
          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div
              className="ag-theme-alpine"
              style={{
                height: 'calc(100vh - 250px)',
                width: "100%",
                minHeight: '400px'
              }}
            >
              <AgGridReact
                rowData={filteredData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                suppressHorizontalScroll={false}
                sideBar={sideBar}
                statusBar={statusPanel}
                // pagination={true}
                // paginationPageSize={20}
                enableRangeSelection={true}
                suppressColumnVirtualisation={true}
                ensureDomOrder={true}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Slider for Trigger Warehouse Indents */}
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

          {triggerStatus === "info" && (
                    <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)", // <-- centers the element
                        zIndex: 1003,
                        backgroundColor: "rgba(255, 255, 255, 0.95)",
                        padding: "20px",
                        borderRadius: "10px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.2)", // optional: nice shadow
                    }}
                    >
                    <div className="inventory-delete-popup" style={{ minWidth: "300px" }}>
                        <p
                        style={{
                            color: "grey",
                            fontSize: "18px",
                            textAlign: "center",
                            fontWeight: "bold",
                            marginBottom: "20px",
                        }}
                        >
                        {triggerNote}
                        </p>
                        <div className="d-flex justify-content-center gap-2">
                        <button
                            className="btn btn-secondary"
                            onClick={onClickingPopupContinueBtn}
                        >
                            Yes
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={onClickDeletePopupCancelBtn}
                        >
                            No
                        </button>
                        </div>
                    </div>
                    </div>
                )}
        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form
              style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
               onSubmit={(e) => { e.preventDefault(); onTriggerSubmit(); }}

            >
             <div className="form-group mb-3">
                <label
                  htmlFor="trigger-date"
                  className="form-label"
                  style={{
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    color: "#444",
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  Date <span style={{ color: "red" }}>*</span>
                </label>

                <DatePicker
                  inputId="trigger-date"
                  value={currentDate}
                  onChange={onChangeTriggerDate}
                  placeholder="Select Date"
                  className="form-control"
                  isClearable
                  required
                  maxDate={latestCycleDate ? new Date(latestCycleDate) : null}
                  style={{
                    width: "100%",
                    fontSize: "0.9rem",
                    padding: "8px 10px",
                    borderRadius: "5px",
                  }}
                />

              </div>
              <div className="text-end mt-4">
                <button
                  type="submit"
                  className="btn px-4"
                  style={{
                    fontSize: "0.9rem",
                    borderRadius: "5px",
                    background: "#93385D",
                    color: "#fff",
                    fontWeight: 500,
                    // cursor: isTrigger === "success" ? "pointer" : "not-allowed",
                    // opacity: isTrigger === "success" ? 1 : 0.6, // visual feedback when disabled
                  }}
                  // disabled={isTrigger !== "success"}
                >
                {/* <ArrowUpCircle size={18} /> */}
                <span style={{marginLeft : "5px"}}>Raise Indents</span>
                </button>
              </div>

            </form>
          </div>
        )}
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

// Styles
const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
    minHeight: '38px'
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: '#333',
    fontSize: "12px"
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: state.isSelected ? 'normal' : 'normal',
  })
};

export default WarehouseIndents;